import { canUseDom } from '../../utils/isSsr'

const SESSION_STORAGE_KEY = 'autoDeliveryProductImages'

export type ProductImageMap = Record<string, string>

/**
 * Retrieves the cached product image map from session storage.
 * Returns an empty object if not available or parsing fails.
 */
export const getProductImageCache = (): ProductImageMap => {
  if (!canUseDom) {
    return {}
  }

  try {
    const raw = window.sessionStorage.getItem(SESSION_STORAGE_KEY)
    if (!raw) {
      return {}
    }
    return JSON.parse(raw) as ProductImageMap
  } catch {
    return {}
  }
}

/**
 * Stores/merges product image entries into session storage.
 * Merges with existing cache to preserve previously stored entries.
 */
export const setProductImageCache = (entries: ProductImageMap): void => {
  if (!canUseDom) {
    return
  }

  try {
    const existing = getProductImageCache()
    const merged = { ...existing, ...entries }
    window.sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(merged))
  } catch {
    // Silently fail — session storage may be full or unavailable
  }
}

/**
 * Removes the product image cache from session storage.
 */
export const clearProductImageCache = (): void => {
  if (!canUseDom) {
    return
  }

  try {
    window.sessionStorage.removeItem(SESSION_STORAGE_KEY)
  } catch {
    // Silently fail
  }
}
